module.exports = __webpack_public_path__ + "r-v3/img/sticker_9_icon.7308f5da.svg";